import * as React from 'react';
import Card from './Card';

type PressReleasesListingProps = {
  endpoint: string;
  itemsPerPage?: string;
  buttonLabel: string;
};

type PressReleaseItem = {
  id: string;
  url: string;
  heading: string;
  date: string;
  description?: string;
};

type EndpointResponse = {
  totalItems: number;
  items: PressReleaseItem[];
};

const PressReleasesListing: React.FC<PressReleasesListingProps> = ({
  endpoint,
  buttonLabel: initialButtonLabel,
  itemsPerPage = '12'
}) => {
  const [page, setPage] = React.useState(1);
  const [showButton, setShowButton] = React.useState<boolean>(false);
  const [buttonLabel, setButtonLabel] = React.useState<string>('');
  const [items, setItems] = React.useState<PressReleaseItem[]>([]);

  const fetchResults = React.useCallback(() => {
    fetch(`${endpoint}?page=${page}&itemsPerPage=${itemsPerPage}`)
      .then(response => response.json())
      .then((data: EndpointResponse) => {
        setItems([...items, ...data.items]);
        const itemsLeft = data.totalItems - page * parseInt(itemsPerPage, 10);
        const buttonCount =
          itemsLeft > parseInt(itemsPerPage, 10) ? itemsPerPage : itemsLeft;
        setShowButton(itemsLeft > 0);

        setButtonLabel(
          initialButtonLabel.replace('[count]', buttonCount.toString())
        );
      });
  }, [endpoint, page]);

  React.useEffect(() => {
    fetchResults();
  }, [page]);

  return (
    <>
      <ul className="press-releases-listing__list">
        {items.map(item => (
          <li key={item.id}>
            <Card {...item} />
          </li>
        ))}
      </ul>
      {showButton && buttonLabel && (
        <button
          type="button"
          className="btn btn--primary press-releases-listing__btn"
          onClick={() => setPage(page + 1)}
        >
          <span>{buttonLabel}</span>
        </button>
      )}
    </>
  );
};

export default PressReleasesListing;
